/**
 * @generated SignedSource<<fa9c7961bf50e3f18b942816d13cdce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DeliverableFinancialBreakdownType = "DELIVERABLE" | "NO_DELIVERABLE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MonthByMonthDeliverableLoader_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly currency: string | null;
  } | null;
  readonly project: {
    readonly aggregatedDeliverableFinancialBreakdown: ReadonlyArray<{
      readonly breakdownType: DeliverableFinancialBreakdownType | null;
      readonly deliverable: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly aggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
    } | null>;
    readonly timeAggregatedFinancialNumbers: ReadonlyArray<{
      readonly breakdownType: DeliverableFinancialBreakdownType | null;
      readonly deliverable: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly timeAggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
    } | null>;
    readonly expenseAggregatedFinancialNumbers: ReadonlyArray<{
      readonly breakdownType: DeliverableFinancialBreakdownType | null;
      readonly deliverable: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly expenseAggregatedFinancialNumbers: ReadonlyArray<string | null> | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "MonthByMonthDeliverableLoader_viewer";
};
export type MonthByMonthDeliverableLoader_viewer$key = {
  readonly " $data"?: MonthByMonthDeliverableLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MonthByMonthDeliverableLoader_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "aggregateLevel",
  "value": "MONTH"
},
v2 = {
  "items": [
    {
      "kind": "Variable",
      "name": "aggregates.0",
      "variableName": "selectedSingleValue"
    }
  ],
  "kind": "ListValue",
  "name": "aggregates"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "excludeOpportunityActuals",
  "variableName": "excludeOpportunityActuals"
},
v7 = {
  "kind": "Literal",
  "name": "filterRowsWithNoValues",
  "value": true
},
v8 = {
  "kind": "Variable",
  "name": "ignoreBaselineWinChance",
  "variableName": "ignoreBaselineWinChance"
},
v9 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v10 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v11 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "breakdownType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "DeliverableType",
  "kind": "LinkedField",
  "name": "deliverable",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeOpportunityActuals"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "expenseSearchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ignoreBaselineWinChance"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectedSingleValue"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "timeSearchQuery"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MonthByMonthDeliverableLoader_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedDeliverableFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedDeliverableFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "timeAggregatedFinancialNumbers",
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "timeSearchQuery"
            },
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedDeliverableFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedDeliverableFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": "timeAggregatedFinancialNumbers",
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "expenseAggregatedFinancialNumbers",
          "args": [
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "expenseSearchQuery"
            },
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "concreteType": "AggregatedDeliverableFinancialBreakdown",
          "kind": "LinkedField",
          "name": "aggregatedDeliverableFinancialBreakdown",
          "plural": true,
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            {
              "alias": "expenseAggregatedFinancialNumbers",
              "args": null,
              "kind": "ScalarField",
              "name": "aggregatedFinancialNumbers",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "0ffe741548bd4f845168bf5b19a75bd2";

export default node;
